import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { getStore } from '../store/store';
import { getKey, SearchScope } from 'owa-search-service';
import getSearchScopeDisplayName from '../utils/getSearchScopeDisplayName';
import { PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { IContextualMenuItem } from 'office-ui-fabric-react/lib/ContextualMenu';
import onFolderDropdownOptionSelected from '../actions/onFolderDropdownOptionSelected';
import getFolderMenuOptions from '../utils/getFolderMenuOptions';

const styles = require('./FolderScope.scss');

export default observer(function FolderScope() {
    if (!getStore().initialSearchScope) {
        return null;
    }

    const menuItems: IContextualMenuItem[] = [];
    const selectedSearchScope = getSelectedOption();
    let selectedFolderScope = getSearchScopeDisplayName(
        selectedSearchScope,
        true /* isSearchFromFolderScope*/
    );
    const items: IContextualMenuItem[] = getFolderMenuOptions(menuItems);
    return (
        <PrimaryButton
            className={styles.foldersScope}
            onRenderText={onRenderText(selectedFolderScope)}
            styles={{
                flexContainer: styles.flexContainer,
            }}
            menuProps={{
                items: items,
                directionalHintFixed: true,
                onItemClick: onItemClick,
                calloutProps: { calloutMaxHeight: 500 },
                gapSpace: 1,
            }}
        />
    );
});

const onRenderText = (selectedFolderScope: string) => () => (
    <div className={styles.folderScopeText}>{selectedFolderScope}</div>
);

function getSelectedOption(): SearchScope {
    const { staticSearchScope: selectedSearchScope, advancedSearchViewState } = getStore();
    return advancedSearchViewState.selectedSearchScope || selectedSearchScope;
}

const onItemClick = (ev?: React.MouseEvent<HTMLElement>, item?: IContextualMenuItem) => {
    const { staticSearchScopeList: searchScopes } = getStore();

    const { key } = item;

    const selectedScope = searchScopes.filter((scope: SearchScope) => {
        return getKey(scope) === key;
    })[0];

    onFolderDropdownOptionSelected({
        key: getKey(selectedScope),
        text: getSearchScopeDisplayName(selectedScope),
        searchScope: selectedScope,
    });
};
